// New color palette
// blue
export const blue950 = '#090934';
export const blue900 = '#111161';
export const blue800 = '#0D2D96';
export const blue700 = '#103FD5';
export const blue600 = '#2053F8';
export const blue500 = '#2F62F9';
export const blue400 = '#5287FA';
export const blue300 = '#83B1FB';
export const blue200 = '#B5D4FD';
export const blue100 = '#DBE9FF';
export const blue50 = '#F5F8FF';
export const blue20 = '#D6EBFF';
export const blue10 = '#e6f3ff'; // dark blue

export const darkBlue900 = '#10275B';
export const darkBlue800 = '#1b3772';
export const darkBlue700 = '#0B1A3B';
export const darkBlue400 = '#344773';
export const darkBlue300 = '#57678C';
export const darkBlue100 = '#BDBECD';
export const darkBlue10 = '#D4D8E1'; // teal

export const teal950 = '#0B3638';
export const teal900 = '#0C554F';
export const teal800 = '#14665F';
export const teal700 = '#447F7A';
export const teal600 = '#70A19D';
export const teal500 = '#95BAB7';
export const teal400 = '#AECECC';
export const teal300 = '#BBDEDE';
export const teal200 = '#C5E5E5';
export const teal100 = '#D5F2F2';
export const teal50 = '#ECF9F9'; // Pink

export const pink950 = '#510624';
export const pink900 = '#841743';
export const pink800 = '#9D174D';
export const pink700 = '#BE185E';
export const pink600 = '#DB2777';
export const pink500 = '#EC4899';
export const pink400 = '#F572B7';
export const pink300 = '#FAA8D4';
export const pink200 = '#FCCFE8';
export const pink100 = '#FCE7F3';
export const pink50 = '#FDF3F8'; // red

export const red950 = '#450A0A';
export const red900 = '#7F1D1D';
export const red800 = '#991B1B';
export const red700 = '#B91C1C';
export const red600 = '#DC2626';
export const red500 = '#EF4444';
export const red400 = '#F87171';
export const red300 = '#FCA5A5';
export const red200 = '#FECACA';
export const red100 = '#FEE2E2';
export const red50 = '#FEECEC';
export const red10 = '#fff8f9'; // green

export const green950 = '#062E16';
export const green900 = '#14532D';
export const green800 = '#176634';
export const green700 = '#17803D';
export const green600 = '#14A44B';
export const green500 = '#2DBA62';
export const green400 = '#5CCC85';
export const green300 = '#93E2B0';
export const green200 = '#C7ECD4';
export const green100 = '#E3F6E9';
export const green50 = '#F0F9F4';
export const green10 = '#eef6f4'; // yellow

export const yellow950 = '#422006';
export const yellow900 = '#713F12';
export const yellow800 = '#854D0E';
export const yellow700 = '#A16207';
export const yellow600 = '#CA8A04';
export const yellow500 = '#EAB308';
export const yellow400 = '#FACC15';
export const yellow300 = '#FDE047';
export const yellow200 = '#FEF08A';
export const yellow100 = '#FEF9C3';
export const yellow50 = '#FEFCE8';
export const yellow10 = '#fef9e5'; // purple

export const purple950 = '#3B0764';
export const purple900 = '#581C87';
export const purple800 = '#6B21A8';
export const purple700 = '#7E22CE';
export const purple600 = '#9333EA';
export const purple500 = '#A855F7';
export const purple400 = '#C084FC';
export const purple300 = '#D8B4FE';
export const purple200 = '#E9D5FF';
export const purple100 = '#F3E8FF';
export const purple50 = '#FAF5FF';
export const purple10 = '#eee4f3'; // gray

export const gray950 = '#030712';
export const gray900 = '#111827';
export const gray800 = '#1F2937';
export const gray700 = '#374151';
export const gray600 = '#4B5563';
export const gray500 = '#6B7280';
export const gray400 = '#9CA3AF';
export const gray300 = '#D1D5DB';
export const gray200 = '#E5E7EB';
export const gray100 = '#F2F3F5';
export const gray50 = '#F9FAFB'; // Beige

export const beige950 = '#302D26';
export const beige900 = '#4A453B';
export const beige800 = '#5B5548';
export const beige700 = '#6C6556';
export const beige600 = '#7A7261';
export const beige500 = '#938B7B';
export const beige400 = '#ACA496';
export const beige300 = '#C2BDB2';
export const beige200 = '#DBD5C9';
export const beige100 = '#F0EEE8';
export const beige50 = '#FAF9F8'; // Orange

export const orange950 = '#4E1A05';
export const orange900 = '#702507';
export const orange800 = '#913009';
export const orange700 = '#B83D0C';
export const orange600 = '#D0581A';
export const orange500 = '#ED7436';
export const orange400 = '#F08B57';
export const orange300 = '#F2B697';
export const orange200 = '#F8C8AF';
export const orange100 = '#FFE4D6';
export const orange50 = '#FFEEE5'; // darkGray

export const darkGray900 = '#2C3742';
export const darkGray800 = '#64687F';
export const darkGray700 = '#7C8098';
export const darkGray300 = '#ABAEBC';
export const darkGray200 = '#D5D6DE';
export const darkGray100 = '#EDEEF0'; // blueGray

export const blueGray700 = '#2B3A47';
export const blueGray500 = '#3e4e5d';
export const blueGray400 = '#77838D';
export const blueGray300 = '#949FA8';
export const blueGray100 = '#B7BECD';
export const blueGray50 = '#F3F5F7';
export const blueGray10 = '#F5F9FF'; // white

export const white = '#ffffff'; // branding

export const brandBlue = '#0B55FF';
export const brandGreen = '#00D2B5';
export const brandPink = '#FE2370';
export const brandYellow = '#FFDA52';
export const brandPurple = '#7B3DFF';
export const brandBgBlue = '#031642';
export const brandBlue100 = '#F5F8FF'; // Legacy color palette
// blue

export const blue = blue700;
export const blueBorder = '#239ed8';
export const blueDark = blue700;
export const blueHover = '#085174';
export const blueContact = '#a8d5eb';
export const blueLight = '#d4ecf7';
export const blueLightBorder = '#48bdf3';
export const blueDarkTheme = '#4bbdf3'; // gray scale

export const black = gray900;
export const blackDark = '#000000';
export const grayDarkest = '#515c61';
export const grayDarker = '#556268';
export const grayDark = blueGray400;
export const muted = blueGray500;
export const gray = '#d1d8db';
export const grayLight = '#e3e8eb';
export const grayLighter = '#eef1f3';
export const grayLightest = '#f4f6f7'; // basic

export const green = green400;
export const greenDark = '#4aa666';
export const yellow = yellow400;
export const yellowLight = '#ffe9ab';
export const yellowDark = '#dfa600';
export const red = red400;
export const redDark = '#e02a2a';
export const purple = purple400; // gfh colors

export const gfhBlue = '#1B74DA';
export const gfhGreen = '#2FCFAC';
export const gfhRed = '#E75C66';